import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { HOME_FAQS } from "./home-content";

/** Accordion FAQ list rendered on the home page. */
export function FaqList() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="divide-y divide-border rounded-2xl glass max-w-3xl">
      {HOME_FAQS.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} className="p-6">
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-center justify-between gap-4 text-left"
            >
              <span className="font-display text-lg">{f.q}</span>
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-primary/15 text-primary">
                {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
              </span>
            </button>
            <div className={`collapsible ${isOpen ? "collapsible-open" : ""}`}>
              <div>
                <p className="pt-3 text-sm text-muted-foreground">{f.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}